const ACTIONS = {
    FETCH_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_BADGES_SUCCESS',
    FETCH_BY_OWNER_PROPERTIES: 'LISTING_EXTENDED/FETCH_BY_OWNER_PROPERTIES',
    FETCH_BY_OWNER_PROPERTIES_SUCCESS: 'LISTING_EXTENDED/FETCH_BY_OWNER_PROPERTIES_SUCCESS',
    FETCH_BY_OWNER_PROPERTIES_FAILED: 'LISTING_EXTENDED/FETCH_BY_OWNER_PROPERTIES_FAILED',
    FETCH_INQUIRY_PROPERTIES: 'LISTING_EXTENDED/FETCH_INQUIRY_PROPERTIES',
    FETCH_INQUIRY_PROPERTIES_SUCCESS: 'LISTING_EXTENDED/FETCH_INQUIRY_PROPERTIES_SUCCESS',
    FETCH_INQUIRY_PROPERTIES_FAILED: 'LISTING_EXTENDED/FETCH_INQUIRY_PROPERTIES_FAILED',
    FETCH_RANKED_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_RANKED_BADGES_SUCCESS',
    FETCH_PRICING_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_PRICING_BADGES_SUCCESS',
    FETCH_SUPERLATIVE_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_SUPERLATIVE_BADGES_SUCCESS',
    FETCH_HOUSE_RULES_SUCCESS: 'LISTING/EXTENDED/FETCH_HOUSE_RULES_SUCCESS',
    FETCH_RECOMMENDED_PROPERTIES: 'LISTING/EXTENDED/FETCH_RECOMMENDED_PROPERTIES',
    FETCH_RECOMMENDED_PROPERTIES_SUCCESS: 'LISTING/FETCH_RECOMMENDED_PROPERTIES_SUCCESS',
    FETCH_RECOMMENDED_PROPERTIES_FAILED: 'LISTING/FETCH_RECOMMENDED_PROPERTIES_FAILED',
    FETCH_GEO_DISTANCE_SUCCEES: 'LISTING/FETCH_GEO_DISTANCE_SUCCEES'
};

const ACTION_CREATORS = {
    fetchRankedBadgesSuccess(rankedBadges) {
        return {
            type: ACTIONS.FETCH_RANKED_BADGES_SUCCESS,
            payload: {
                rankedBadges
            }
        };
    },
    fetchPricingBadgesSuccess(pricingBadges) {
        return {
            type: ACTIONS.FETCH_PRICING_BADGES_SUCCESS,
            payload: {
                pricingBadges
            }
        };
    },
    fetchSuperlativeBadgesSuccess(superlativeBadges) {
        return {
            type: ACTIONS.FETCH_SUPERLATIVE_BADGES_SUCCESS,
            payload: {
                superlativeBadges
            }
        };
    },
    fetchRecommendedPropertiesSuccess({
        recommendedProperties,
        clientRequestId,
        recommendedPropertiesAlternativeTitle
    }) {
        return {
            type: ACTIONS.FETCH_RECOMMENDED_PROPERTIES_SUCCESS,
            payload: {
                recommendedProperties,
                clientRequestId,
                recommendedPropertiesAlternativeTitle
            }
        };
    },
    fetchRecommendedPropertiesFailed() {
        return {
            type: ACTIONS.FETCH_RECOMMENDED_PROPERTIES_FAILED,
            payload: {}
        };
    },
    fetchByOwnerPropertiesSuccess({recommendedProperties: byOwnerProperties, clientRequestId}) {
        return {
            type: ACTIONS.FETCH_BY_OWNER_PROPERTIES_SUCCESS,
            payload: {
                byOwnerProperties,
                byOwnerClientRequestId: clientRequestId
            }
        };
    },
    fetchByOwnerPropertiesFailed() {
        return {
            type: ACTIONS.FETCH_BY_OWNER_PROPERTIES_FAILED,
            payload: {}
        };
    },
    fetchInquiryPropertiesSuccess({recommendedProperties: inquiryProperties, clientRequestId}) {
        return {
            type: ACTIONS.FETCH_INQUIRY_PROPERTIES_SUCCESS,
            payload: {
                inquiryProperties,
                inquiryClientRequestId: clientRequestId
            }
        };
    },
    fetchInquiryPropertiesFailed() {
        return {
            type: ACTIONS.FETCH_INQUIRY_PROPERTIES_FAILED,
            payload: {}
        };
    },
    fetchGeoDistanceSuccess(geoRelativeDistances) {
        return {
            type: ACTIONS.FETCH_GEO_DISTANCE_SUCCEES,
            payload: {
                geoRelativeDistances
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
